import { Flex } from '../UI/Flex/Flex';
import loading from './loading.svg';
import Lottie from 'react-lottie';
import animData from './loading.json';
interface ILoadingProps {
    width?: number;
    height?: number;
}
export const LoadingAnimation = (p: ILoadingProps) => {
    const w = p.width || 400;
    const h = p.height || 400;
    const defaultOptions = {
        loop: true,
        autoplay: true,
        play: true,
        animationData: animData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return <Lottie options={defaultOptions} height={h} width={w} />;
};
